import React from "react";
import LModal from "../../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../../common/components/Modals/ModalHeader/ModalHeader";

interface IAsteronPrezzyCardSpecialOfferModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const AsteronPrezzyCardSpecialOfferModal: React.FC<IAsteronPrezzyCardSpecialOfferModalProps> = (
    props
) => {
    const { isOpen, onClose } = props;

    return (
        <LModal
            Header={() => (
                <ModalHeader
                    onClose={onClose}
                    title="Prezzy Card Campaign Terms and Conditions"
                />
            )}
            calcHeightMode="auto"
            width="wide"
            isOpen={isOpen}
            onClose={onClose}>
            {() => {
                return (
                    <React.Fragment>
                        <p>
                            For every $500 of new or additional premium with Asteron Life,
                            they will shout you a $50 Prezzy card (up to $5000).
                        </p>
                        <h3>Prezzy Card Campaign Terms and Conditions</h3>
                        <p>
                            Asteron Life Limited (&apos;Asteron&apos;) is offering a
                            Prezzy Card (&quot;Gift&quot;) to those participants who take
                            out a new Qualifying Policy/Benefit, add a new benefit and/or
                            increase an existing benefit during the promotional period.
                        </p>

                        <ul>
                            <li>For the purposes of these Terms and Conditions:</li>
                            <ul>
                                <li>
                                    &quot;Qualifying Policy/Benefit&quot; means either a
                                    new policy, underwritten by Asteron, the premium for
                                    which exceeds $500 per year; or an increase in
                                    existing cover, or addition or increase of a benefit
                                    on an existing policy underwritten by Asteron, which
                                    results in additional premium of $500 per year.
                                </li>
                                <li>
                                    Applications for a Qualifying Policy/Benefit must be
                                    submitted between 18 October 2021 and 17 December
                                    2021, and the policy issued by 31 March 2022;
                                </li>
                                <li>
                                    The value of the Gift will be $50 for every $500 of
                                    new premium, or additional premium on an existing
                                    policy, to a maximum of $5000.
                                </li>
                            </ul>
                            <li>
                                Asteron will endeavour to send your Gift by post within
                                one month of the Qualifying Policy being issued, but will
                                have no liability for any delay in meeting this time
                                frame.
                            </li>
                        </ul>

                        <h4>Eligibility Criteria</h4>

                        <ul>
                            <li>You will not be eligible for the Gift if:</li>
                            <ul>
                                <li>
                                    You take a new Qualifying Policy/Benefit out but then
                                    cancel it at any time prior to the later of the Gift
                                    being dispatched to you or one month after the issue
                                    of the Qualifying Policy/Benefit.
                                </li>
                            </ul>
                            <li>
                                Your application for a Qualifying Policy/Benefit with
                                Asteron is subject to standard underwriting criteria.
                            </li>
                            <li>
                                Asteron may, in its absolute discretion, refuse to provide
                                the Gift to a customer who, in Asteron’s view, has acted
                                fraudulently or not complied with these Terms and
                                Conditions.
                            </li>
                            <li>
                                This offer is open to New Zealand residents only.
                                Employees, contractors, and their immediate families
                                (including partners, siblings, grandparents, parents,
                                children and grandchildren), of the following, are not
                                eligible for the offer:
                            </li>
                            <ul>
                                <li>Asteron;</li>
                                <li>
                                    any company with which the Asteron has a current joint
                                    venture arrangement;
                                </li>
                                <li>
                                    shareholders and suppliers of Asteron; including
                                    agencies, contractors, subcontractors, suppliers and
                                    affiliated providers.
                                </li>
                            </ul>
                        </ul>

                        <h4>Limitation of Liability</h4>
                        <p>
                            Asteron, its related companies and agencies associated with
                            this offer, will not be liable for any loss, claim, cost,
                            expense, liability or injury (“Loss”) suffered by any person
                            in any way associated with the offer or Gift, except where
                            such Loss cannot be excluded by law.
                        </p>

                        <h4>Other:</h4>
                        <ul>
                            <li>
                                The offer and/or the Gift is not transferable and cannot
                                be exchanged for cash.
                            </li>
                            <li>
                                Prezzy card is a registered trademark of Kiwibank Limited.
                                Standard Prezzy card terms and conditions apply, see{" "}
                                <a
                                    target="_blank"
                                    rel="noopener"
                                    href="https://www.prezzycard.co.nz/terms-and-conditions">
                                    prezzycard.co.nz/terms-and-conditions
                                </a>
                                .
                            </li>
                            <li>
                                Asteron reserves the right to modify the terms of this
                                promotion at its discretion and to extend, modify,
                                postpone or cancel the promotion at any time.
                            </li>
                            <li>
                                Asteron’s decision in relation to the promotion is final
                                and no correspondence will be entered into.
                            </li>
                            <li>
                                Policy cover is subject to standard underwriting
                                conditions and to policy terms and conditions. Please
                                refer to relevant policy document for full policy terms
                                and conditions.
                            </li>
                            <li>
                                The promoter of this offer is Asteron Life Limited, which
                                has its registered office at 55 Featherston Street,
                                Wellington.
                            </li>
                            <li>
                                These Terms and Conditions are governed and construed in
                                accordance with New Zealand law and shall be subject to
                                the exclusive jurisdiction of the New Zealand courts.
                            </li>
                        </ul>
                        <p className="text-light">
                            This promotion is not affiliated with or endorsed by
                            LifeDirect.
                        </p>
                    </React.Fragment>
                );
            }}
        </LModal>
    );
};

export default AsteronPrezzyCardSpecialOfferModal;
